import { ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/system";

type Props = {
  groupName: string;
  carrier: string;
  coverage: string;
  subTitleText?: ReactElement<unknown>;
  sticky?: boolean;
};

const CoverageSubheader = ({
  groupName,
  carrier,
  coverage,
  subTitleText,
  sticky = false,
}: Props) => {
  const theme = useTheme();

  const subHeaderItem = (label: string, value: string, maxWidth = "33.33%") => (
    <Box
      display="flex"
      maxWidth={maxWidth}
      sx={{ wordWrap: "break-word" }}
      gap={1}
    >
      <Typography fontWeight={600} fontSize="1rem">
        {label}
      </Typography>
      <span>{value}</span>
    </Box>
  );

  return (
    <Box
      sx={{
        bgcolor: theme.palette.neutrals.neutral_50,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        padding: theme.spacing(4),
        boxShadow: "rgba(0, 0, 0, 0.5) 0px 15px 10px -15px",
        zIndex: 999,
        width: "100%",
        position: sticky ? "fixed" : "relative",
      }}
    >
      {sticky && (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gap={1}>
            Policy Details
          </Typography>
        </Box>
      )}
      <Box display="flex" gap={10}>
        {subHeaderItem("Group Name: ", groupName, "40%")}
        {subHeaderItem("Carrier: ", carrier, "35%")}
        {subHeaderItem("Coverage: ", coverage, "25%")}
      </Box>
      <Typography fontStyle="italic">
        Need help with this data? Contact us{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="mailto:help@centrobenefits.com"
        >
          here
        </a>
        .&nbsp;
        {!!subTitleText && subTitleText}
      </Typography>
    </Box>
  );
};

export default CoverageSubheader;
